import { blogIndexSchema } from "./schemaPatchGraphs";

/** Meaningful schema-only correction for /blog/; no article or archive copy changes. */
export const BLOG_INDEX_WINNER09_MODIFIED = "2026-11-04";

type VisibleIndexPost = { slug: string; title: string };

export function buildBlogIndexWinner09Schema(visiblePosts: VisibleIndexPost[]) {
  const canonical = "https://integrated.social/blog/";
  const posts = Array.from(new Map(visiblePosts.map((post) => [post.slug, post])).values());
  return {
    "@context": "https://schema.org",
    "@graph": blogIndexSchema["@graph"].map((node) => {
      if (node["@type"] === "CollectionPage") {
        return {
          ...node,
          dateModified: BLOG_INDEX_WINNER09_MODIFIED,
          breadcrumb: { "@id": `${canonical}#breadcrumb` },
        };
      }
      if (node["@type"] === "ItemList") {
        return {
          ...node,
          // Featured guides precede recent articles; this is not a date or quality ranking.
          itemListOrder: "https://schema.org/ItemListOrderUnordered",
          numberOfItems: posts.length,
          itemListElement: posts.map((post, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: post.title,
            url: `${canonical}${post.slug}/`,
          })),
        };
      }
      return node;
    }),
  };
}
